module.exports = __webpack_public_path__ + "static/img/handle.14ee7013.png";